module.exports = __webpack_public_path__ + "img/03.e7df2cfc.jpg";